module.exports = __webpack_public_path__ + "img/logo-main.2447d68a.png";